// extracted by mini-css-extract-plugin
export default {"copyWrapper":"urknJn17Fucg9V2dV9SG2w==","copyTip":"F-46-rHV2twzILo1Kgm4DQ==","show-and-hide":"jC+GaQuFFxoJcZu+GaxtNA=="};